import queryString from 'query-string'

const queryVars = ['showLocation', 'firstName', 'lastName', 'email', 'iframe']

window.firstAccessQueryString = queryString.parse(window.location.search)
const { showLocation, firstName, lastName, email, iframe } = window.firstAccessQueryString
window.__iframe = iframe
window.__showLocation = showLocation
window.__firstName = firstName
window.__lastName = lastName
window.__email = email

if (window.history.pushState) {
  window.history.pushState = (f => function pushState() {
    const ret = f.apply(this, arguments)
    window.dispatchEvent(new Event('pushstate'))
    window.dispatchEvent(new Event('x-locationchange'))
    return ret
  })(window.history.pushState)
}

if (window.history.replaceState) {
  window.history.replaceState = (f => function replaceState() {
    const ret = f.apply(this, arguments)
    window.dispatchEvent(new Event('replacestate'))
    window.dispatchEvent(new Event('x-locationchange'))
    return ret
  })(window.history.replaceState)
}

window.addEventListener('popstate', () => {
  window.dispatchEvent(new Event('x-locationchange'))
})

for (const queryVar of queryVars) {
  if (!window.history.replaceState) {
    break
  }
  if (window[`__${queryVar}`]) {
    window.addEventListener('x-locationchange', () => {
      const query = queryString.parse(window.location.search)
      if (query[queryVar]) {
        return
      }
  
      Object.assign(query, { [queryVar]: window[`__${queryVar}`] })
  
      window.history.replaceState(
        {},
        '',
        `${window.location.pathname}?${queryString.stringify(query)}`
      )
    })
  }
}
